import { ISize } from '@pressreader/geometry';

import { IArticleImage } from './article.image';

type ParagraphType = 'image' | 'opinion' | 'text' | 'title' | 'video';

interface IParagraphBase<TType = ParagraphType> {
    type: TType;
}

enum Formatting {
    None = 0,
    Bold = 1,
    Italic = 2,
    Link = 3,
    Quote = 4,
    Uppercase = 5,
    Lowercase = 6,
}

enum TitleStyle {
    None = 0,
    Title = 1,
    Subtitle = 2,
    SubtitleEmphasis = 3,
}

interface IMarkup {
    start: number;
    end: number;
    formatting: Formatting;
    attributes: unknown;
}

interface ITextParagraph<TType extends ParagraphType = 'text'> extends IParagraphBase<TType> {
    text: string;
    markups: IMarkup[] | null;
}

interface ITitleParagraph extends ITextParagraph<'title'> {
    style: TitleStyle;
}

interface IImageParagraph extends IParagraphBase<'image'> {
    image: IArticleImage | null;
    caption: string;
}

interface IOpinionParagraph extends IParagraphBase<'opinion'> {
    opinionId: string;
}

interface IVideoParagraph extends IParagraphBase<'video'>, ISize {
    url: string;
    caption: string;
    thumbnail: string;
}

type IParagraph = ITextParagraph | ITitleParagraph | IImageParagraph | IOpinionParagraph | IVideoParagraph;

function isImageParagraph(paragraph: IParagraph): paragraph is IImageParagraph {
    return paragraph.type === 'image';
}

export {
    ParagraphType,
    IParagraph,
    ITextParagraph,
    IMarkup,
    ITitleParagraph,
    Formatting,
    TitleStyle,
    IVideoParagraph,
    IImageParagraph,
    IOpinionParagraph,
};
export { isImageParagraph };
